export default __webpack_public_path__ + "static/cushion.mobile.inspirations-ea4cba9290d55b54fd7ffa312da310d9.jpg";